import { createElement } from 'react';

import { Controller } from '@hotwired/stimulus';
import { createRoot } from 'react-dom/client';

import { logError } from '../lib/logger';

import ProfileSetupApp from '../components/profile_setup/ProfileSetupApp';

function parseUser(json) {
  if (!json) return null;
  try {
    return JSON.parse(json);
  } catch (error) {
    logError('ProfileSetupController', 'Failed to parse user JSON', { error });
    return null;
  }
}

export default class extends Controller {
  static values = {
    user: String,
  };

  connect() {
    this.root = createRoot(this.element);
    this.root.render(
      createElement(ProfileSetupApp, {
        user: parseUser(this.userValue),
      }),
    );
  }

  disconnect() {
    this.root?.unmount();
    this.root = null;
  }
}
